import { ReactComponent as CalendarIcon } from "../../../../assets/svg/icons/calendar.svg";
import { format } from "date-fns";
import { useFilter } from "../../../../hooks/useFilter";
import "../styles.css"
import { ButtonExportPDF } from "../../../Buttons/ButtonExportPDF";
import { ButtonExportExcel } from "../../../Buttons/ButtonExportExcel";

type FilterDateDashboardProps = {
    exportPDF?: boolean;
    onExportExcel?: () => void;
}

export function FilterDateDashboard({ exportPDF = true, onExportExcel }: FilterDateDashboardProps) {
    const {
        setModalCalendarFilter,
        rangeDays,
        setRangeDays,
        setFocusLastDay,
        setViewRangeDays,
        selectRangeDate,
        setSelectRangeDate
    } = useFilter();

    const rangeButtonClass = (isActive: boolean) =>
        `dashBoardSupplement__range-button${isActive ? " is-active" : ""}`;

    return (
        <section className="dashBoardSupplement__container">
            <div className="dashBoardInfoSupplement__container">
                <div className="dashBoardSupplement__content">
                    <div className="dashBoardSupplement__range-buttons">
                        <button
                            type="button"
                            className={rangeButtonClass(selectRangeDate == 0)}
                            onClick={() => {
                                setSelectRangeDate(0);

                                const now = new Date();
                                const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                                const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

                                const range = {
                                    from: firstDayOfLastMonth,
                                    to: firstDayOfCurrentMonth
                                };
                                setRangeDays(range);
                                setViewRangeDays(range);
                            }}
                        >
                            Último mês
                        </button>

                        <button
                            type="button"
                            className={rangeButtonClass(selectRangeDate == 1)}
                            onClick={() => {
                                setSelectRangeDate(1);

                                const now = new Date();
                                const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                                const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 6, 1);

                                const range = {
                                    from: firstDayOfLastMonth,
                                    to: firstDayOfCurrentMonth
                                };
                                setRangeDays(range);
                                setViewRangeDays(range);
                            }}
                        >
                            Últimos 6 meses
                        </button>

                        <button
                            type="button"
                            className={rangeButtonClass(selectRangeDate == 2)}
                            onClick={() => setSelectRangeDate(2)}
                        >
                            Personalizado
                        </button>
                    </div>

                    <div className="dashBoardSupplement__date-row">

                        <div className="dataFilter__owner--container" onClick={() => {
                            setSelectRangeDate(2);
                            setModalCalendarFilter(true);
                            setFocusLastDay(false);
                        }}>
                            <small>De</small>
                            <div>
                                <h6>{format(rangeDays?.from ? new Date(rangeDays.from) : new Date(), 'dd/MM/yyyy')}</h6>
                                <CalendarIcon />
                            </div>
                        </div>

                        <div className="dataFilter__owner--container" onClick={() => {
                            setSelectRangeDate(2);
                            setModalCalendarFilter(true);
                            if (rangeDays?.from?.toDateString() != rangeDays?.to?.toDateString()) {
                                setFocusLastDay(true);
                            }
                            else {
                                setFocusLastDay(false);
                            }
                        }}>
                            <small>Até</small>
                            <div>
                                <h6>{format(rangeDays?.to ? new Date(rangeDays.to) : new Date(), 'dd/MM/yyyy')}</h6>
                                <CalendarIcon />
                            </div>
                        </div>
                    </div>

                    {exportPDF && (
                        <div className="dashBoardSupplement__actions">
                            <ButtonExportPDF />
                            {onExportExcel && <ButtonExportExcel onClick={onExportExcel} />}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}